import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import mainHelper, {apiCall} from "../../../helpers/MainHelper";
import ReactLoading from "react-loading";

class StockMovementAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            warehouses: [],
            stockItems: [],
            currentStock: null,
            selectedStockItem: null,
            formData : {
                warehouse_id:'',
                stock_item_id:'',
                movement_type:'purchase',
                quantity:'',
                notes:'',
                movement_date: new Date().toISOString().split('T')[0]
            }
        }
    }

    componentDidMount() {
        this.fetchWarehouses();
        this.fetchStockItems();
    }

    fetchWarehouses = async () => {
        try {
            const response = await apiCall('business/stock/warehouse/select-list','get');
            this.setState({warehouses: response.data || []});
        } catch (e) {
            console.error(e);
        }
    }

    fetchStockItems = async () => {
        try {
            const response = await apiCall('business/stock/item/select-list','get');
            this.setState({stockItems: response.data || []});
        } catch (e) {
            console.error(e);
        }
    }

    fetchStockItemDetail = async (itemId) => {
        try {
            const response = await apiCall(`business/stock/item/info/${itemId}`,'get');
            if(response.status === 'success' && response.data) {
                this.setState({selectedStockItem: response.data});
            }
        } catch (e) {
            console.error(e);
        }
    }

    handleChange = (e) => {
        const {id,value} = e.target;
        this.setState(prevState => ({
            formData : {
                ...prevState.formData,
                [id] : value
            }
        }), () => {
            // Ürün değiştiğinde detaylarını getir
            if(id === 'stock_item_id' && value) {
                this.fetchStockItemDetail(value);
            }

            // Depo veya ürün değiştiğinde mevcut stoğu kontrol et
            if((id === 'warehouse_id' || id === 'stock_item_id') &&
               this.state.formData.warehouse_id &&
               this.state.formData.stock_item_id) {
                this.fetchCurrentStock();
            }
        })
    }

    fetchCurrentStock = async () => {
        const {warehouse_id, stock_item_id} = this.state.formData;
        try {
            const response = await apiCall(`business/stock/item/warehouse-stock/${stock_item_id}`,'get');
            if(response.status === 'success' && response.data) {
                const warehouseStock = response.data.find(ws => ws.warehouse_id == warehouse_id);
                this.setState({currentStock: warehouseStock ? warehouseStock.quantity : 0});
            } else {
                this.setState({currentStock: 0});
            }
        } catch (e) {
            console.error(e);
            this.setState({currentStock: 0});
        }
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({loading:true});
        const {formData} = this.state;
        const movementFormData = new FormData();
        Object.keys(this.state.formData).forEach(key => {
            if(formData[key]) {
                movementFormData.append(key,formData[key]);
            }
        });

        try {
            const response = await apiCall('business/stock/movement/add','post',movementFormData);
            this.setState({loading:false});
            mainHelper.toastMessage(response.status,response.message);
            if(response.status === 'success') {
                this.props.history.push('/stock/movements');
            }
        }catch (e) {
            this.setState({loading:false});
        }
    }

    render() {
        const {loading, warehouses, stockItems, formData, currentStock, selectedStockItem} = this.state;
        const isOutboundMovement = ['sale', 'transfer_out'].includes(formData.movement_type);
        const isInboundMovement = ['purchase', 'transfer_in', 'return'].includes(formData.movement_type);
        const hasInsufficientStock = isOutboundMovement && currentStock !== null && parseFloat(formData.quantity) > currentStock;

        // Max stock level kontrolü
        const maxStockLevel = selectedStockItem?.max_stock_level || 0;
        const newQuantity = isInboundMovement && currentStock !== null ? currentStock + parseFloat(formData.quantity || 0) : 0;
        const exceedsMaxStock = isInboundMovement && maxStockLevel > 0 && newQuantity > maxStockLevel;
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Stok Hareketi Ekle"
                            Breadcrumb={[
                                { name: "Stok Yönetimi", navigate: "" },
                                { name: "Stok Hareketleri", navigate: "stock/movements" },
                                { name: "Yeni Hareket", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="card">
                                <form onSubmit={this.handleSubmit}>
                                    <div className="body">
                                        <div className="row clearfix justify-content-center">
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>Depo *</label>
                                                    <select
                                                        id="warehouse_id"
                                                        className="form-control"
                                                        value={formData.warehouse_id}
                                                        onChange={this.handleChange}
                                                        required
                                                    >
                                                        <option value="">Depo Seçiniz</option>
                                                        {warehouses.map(warehouse => (
                                                            <option key={warehouse.id} value={warehouse.id}>
                                                                {warehouse.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>Stok Kalemi *</label>
                                                    <select
                                                        id="stock_item_id"
                                                        className="form-control"
                                                        value={formData.stock_item_id}
                                                        onChange={this.handleChange}
                                                        required
                                                    >
                                                        <option value="">Stok Kalemi Seçiniz</option>
                                                        {stockItems.map(item => (
                                                            <option key={item.id} value={item.id}>
                                                                {item.name} {item.sku ? `(${item.sku})` : ''}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>Hareket Tipi *</label>
                                                    <select
                                                        id="movement_type"
                                                        className="form-control"
                                                        value={formData.movement_type}
                                                        onChange={this.handleChange}
                                                        required
                                                    >
                                                        <option value="purchase">Satın Alma (Giriş)</option>
                                                        <option value="sale">Satış (Çıkış)</option>
                                                        <option value="adjustment">Düzeltme</option>
                                                        <option value="return">İade</option>
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>Miktar *</label>
                                                    <input
                                                        id="quantity"
                                                        className={`form-control ${hasInsufficientStock ? 'is-invalid' : ''}`}
                                                        placeholder="Miktar"
                                                        type="number"
                                                        step="0.01"
                                                        value={formData.quantity}
                                                        onChange={this.handleChange}
                                                        required
                                                    />
                                                    {currentStock !== null && (
                                                        <small className={`form-text ${hasInsufficientStock || exceedsMaxStock ? 'text-danger' : 'text-info'}`}>
                                                            <strong>Mevcut Stok:</strong> {Math.round(currentStock)} adet
                                                            {maxStockLevel > 0 && isInboundMovement && (
                                                                <span className="d-block">
                                                                    <strong>Maksimum:</strong> {Math.round(maxStockLevel)} adet
                                                                </span>
                                                            )}
                                                            {hasInsufficientStock && (
                                                                <span className="d-block text-danger">
                                                                    ⚠️ Yetersiz stok! Depoda sadece {Math.round(currentStock)} adet var.
                                                                </span>
                                                            )}
                                                            {exceedsMaxStock && (
                                                                <span className="d-block text-danger">
                                                                    ⚠️ Maksimum stok aşılacak! Girişten sonra {Math.round(newQuantity)} adet olacak, maksimum {Math.round(maxStockLevel)} adet.
                                                                </span>
                                                            )}
                                                        </small>
                                                    )}
                                                    {!currentStock && (
                                                        <small className="form-text text-muted">
                                                            {formData.movement_type === 'adjustment' ?
                                                                'Düzeltme: Yeni stok miktarını girin' :
                                                                'Çıkış hareketleri için pozitif değer girin (otomatik olarak düşülecektir)'}
                                                        </small>
                                                    )}
                                                </div>
                                                <div className="form-group">
                                                    <label>Hareket Tarihi *</label>
                                                    <input
                                                        id="movement_date"
                                                        className="form-control"
                                                        type="date"
                                                        value={formData.movement_date}
                                                        onChange={this.handleChange}
                                                        required
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Notlar</label>
                                                    <textarea
                                                        id="notes"
                                                        className="form-control"
                                                        placeholder="Notlar"
                                                        rows="3"
                                                        value={formData.notes}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="body">
                                        <div className="row clearfix justify-content-center">
                                            <div className="col-lg-6 col-md-12">
                                                {loading ? (
                                                    <button className="btn btn-outline-primary btn-block" disabled={true} style={{textAlign: "-webkit-center"}}>
                                                        Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2"></ReactLoading>
                                                    </button>
                                                ) :
                                                <button
                                                    className="btn btn-outline-primary btn-block"
                                                    type="submit"
                                                    disabled={hasInsufficientStock || exceedsMaxStock}
                                                >
                                                    Kaydet
                                                </button>}
                                                {hasInsufficientStock && (
                                                    <small className="form-text text-danger text-center d-block mt-2">
                                                        Yetersiz stok nedeniyle kayıt yapılamaz
                                                    </small>
                                                )}
                                                {exceedsMaxStock && (
                                                    <small className="form-text text-danger text-center d-block mt-2">
                                                        Maksimum stok seviyesi aşıldığı için kayıt yapılamaz
                                                    </small>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({stockReducer}) => ({});

export default withRouter(connect(mapStateToProps, {})(StockMovementAdd));

